/**
 * @module docTypes
 * @description A list of docTypes
 */

export const docTypes = [
	'invoices',
	'quotes',
	'creditNotes',
	'deliveryNotes',
	'orders',
	'payments',
	'expenses',
	'asserts',
	'payslips',
	'bookings',
	'pos',
] as const;
export type DocTypes = (typeof docTypes)[number];
